(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDetails extends HTMLElement {
    constructor() {
      super();

      this.detailsElement = this.querySelector('details');
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    onMouseEnter() {
      this.detailsElement.setAttribute('open', '');
    }

    onMouseLeave() {
      this.detailsElement.removeAttribute('open');
    }
  }

  customElements.define('header-details', HeaderDetails);

  } catch(e) { console.error(e); }
})();
})();
